import axios from "axios";
import defaultHeaders from "./default-headers";

export const getListingPublishingRules = async () => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/contract/publishing_rules/latest/`;

  const response = await axios.get(url, {
    headers: {
      ...defaultHeaders,
    },
  });

  return response.data;
};
